export default "__VITE_ASSET__axThyTxf__"